import React from 'react';
import styled, { css } from 'styled-components/macro';
import { AccordionItemContainer, ButtonStyled, ContentStyled } from '@yme/atoms/accordion';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { HEADER_HEIGHT } from '@yme/common/constants';
import { colorBlackTransparent100, colorBlackTransparent300, colorBrandYamahaRed, colorCoreBackground1000, colorCoreBlack300, colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
import { MegamenuListItemStyled, MegamenuListStyled } from '../styled';
export const MainMenuNavStyled = styled.nav `
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  transform: ${({ isRightToLeft }) => (isRightToLeft ? 'translateX(100%)' : 'translateX(-100%)')};
  transition: transform 0.2s ease-out;

  z-index: ${Z_INDEX.level9};
  background-color: ${({ isFirstMenu }) => isFirstMenu ? colorCoreWhite1000 : colorCoreBackground1000};

  padding: ${INDENT.none};
  width: 100%;
  ${({ scrollPosition }) => `height: calc(100% - ${HEADER_HEIGHT.sm} + ${scrollPosition}px);`}

  ${ADAPTIVE.minWidth.tablet} {
    ${({ scrollPosition }) => `height: calc(100% - ${HEADER_HEIGHT.md} + ${scrollPosition}px);`}
  }

  ${({ isMenuShowed }) => isMenuShowed && 'transform: translateX(0);'};
`;
// Styles for Mobile and Tablet views
const ProfileMenuAfter = css `
  &::after {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: ${Z_INDEX.levelNegative1};

    background-color: ${colorBlackTransparent100};
    border-radius: 20px;
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%);
  }

  &:active {
    &::after {
      display: block;
    }
  }

  @media (hover: hover) {
    &:hover {
      &::after {
        display: block;
      }
    }
  }
`;
export const HamburgerButtonStyled = styled.div `
  display: flex;
  align-items: center;
`;
export const HamburgerMenuStyled = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
({ isRightToLeft, ...props }) => React.createElement(SVGIcon, { ...props })) `
  ${ProfileMenuAfter};

  display: inline-flex;
  position: relative;
  padding: ${INDENT.xxxs};
  cursor: pointer;

  align-items: center;

  dominant-baseline: middle; /* TODO: (D.K.) Need investigate this approach */

  align-self: center;
`;
export const ScrollContainerStyled = styled.div `
  ${CustomScroll};

  max-height: 100%;
  padding: 0;
  border: none;
  border-bottom: 6px solid transparent;
`;
export const MobileMegamenuListStyled = styled(MegamenuListStyled) `
  height: auto;
  max-height: none;
  padding: 0;
  border-top: 1px solid ${colorCoreGray500};
  box-sizing: border-box;
`;
export const MobileMegamenuListItemStyled = styled(MegamenuListItemStyled) `
  ${({ isLink }) => !isLink && `border-bottom: 1px solid ${colorCoreGray500}`};
  background-color: ${({ isLink }) => (isLink ? defaultTransparent : colorCoreWhite1000)};

  padding: ${({ isRightToLeft }) => isRightToLeft ? `0 ${INDENT.sm} 0 ${INDENT.xs}` : `0 ${INDENT.xs} 0 ${INDENT.sm}`};

  ${({ withAccordion }) => withAccordion && 'padding: 0'};

  ${ADAPTIVE.maxWidth.mobile} {
    padding: ${({ isRightToLeft }) => isRightToLeft ? `0 ${INDENT.xs} 0 ${INDENT.xxs}` : `0 ${INDENT.xxs} 0 ${INDENT.xs}`};

    ${({ withAccordion }) => withAccordion && 'padding: 0'};
  }

  ${AccordionItemContainer} {
    width: 100%;
    border: none;

    ${ContentStyled} {
      padding: 0;
      border-top: 1px solid ${colorCoreGray500};
      background-color: ${colorCoreBackground1000};

      ul {
        transform: none;
      }
    }

    ${ButtonStyled} {
      padding-right: ${INDENT.xs};
      padding-left: ${INDENT.xs};

      ${ADAPTIVE.minWidth.tablet} {
        ${({ isRightToLeft }) => isRightToLeft
    ? css `
                padding-right: ${INDENT.sm};
                padding-left: ${INDENT.xs};
              `
    : css `
                padding-right: ${INDENT.xs};
                padding-left: ${INDENT.sm};
              `};
      }
    }
  }

  ${({ isFirstLevel }) => !isFirstLevel &&
    css `
      span {
        ${getTextStyles('Ubuntu', 400, 14, 16)}
        text-transform: none;
      }
    `}
`;
export const UnitWrapperStyled = styled.div `
  width: calc(25% - ${INDENT.xxxs});
  margin: 4px;
  padding: 0;

  ${ADAPTIVE.maxWidth.mobile} {
    width: 100%;
    margin: 4px 0;
  }
`;
export const DealerLocatorWrapper = styled.div `
  .menu-dealer-locator-button {
    display: flex;
    width: 44px;
    height: 44px;

    & > span {
      border-radius: ${CORNER_RADIUS.s};
      direction: ltr;
      background-color: #ffffff;
      border: 1px solid ${colorBlackTransparent300};
      display: block;
      position: relative;
    }
  }

  &:hover {
    .menu-dealer-locator-button {
      svg {
        stroke: ${colorCoreBlack900Base};
      }
    }
  }
`;
export const WishlistButtonWrapper = styled.div `
  .menu-wishlist-button {
    display: flex;
    width: 44px;
    height: 44px;

    & > span {
      border-radius: ${CORNER_RADIUS.s};
      direction: ltr;
      background-color: #ffffff;
      border: 1px solid ${colorBlackTransparent300};
      display: block;
      position: relative;

      ${({ hasWishlistItems }) => hasWishlistItems &&
    css `
          ::before {
            content: '';
            display: block;
            position: absolute;
            right: 5px;
            top: 6px;
            width: 8px;
            height: 8px;
            z-index: ${Z_INDEX.level1};
            border-width: 2px;
            border-radius: 50%;
            border-style: solid;
            background-color: ${colorBrandYamahaRed};
            border-color: white;
          }
        `}
    }
  }
`;
export const LanguageSelectorContainerStyled = styled.div `
  margin-top: auto;
  ${({ isRightToLeft }) => isRightToLeft && 'margin-left: auto'};

  padding: ${INDENT.xs};
  display: flex;
  justify-content: space-between;
`;
export const AnniversaryButtonStyled = styled.button `
  ${getTextStyles('Ubuntu', 400, 14, 20)};

  text-align: center;
  box-sizing: border-box;
  cursor: pointer;

  background-color: ${colorCoreWhite1000};
  border: 1px solid ${colorBlackTransparent300};
  color: ${colorCoreBlack300};

  display: flex;
  white-space: normal;
  justify-content: center;
  align-items: center;
  gap: 6px;

  width: 100%;

  padding: 16px 0;
  text-transform: capitalize;

  border-radius: ${CORNER_RADIUS.s};
  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};

  & > span {
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;
